import { toString30pk9tzaqopn as toString } from './Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from './js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { listOf1jh22dvmctj1r as listOf } from './collections/CollectionsKt.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PairClass;
function Pair() {
  if (PairClass === VOID) {
    class $ {
      constructor(first, second) {
        this.af_1 = first;
        this.bf_1 = second;
      }
      toString() {
        return '(' + toString(this.af_1) + ', ' + toString(this.bf_1) + ')';
      }
      cf() {
        return this.af_1;
      }
      df() {
        return this.bf_1;
      }
      hashCode() {
        var result = this.af_1 == null ? 0 : hashCode(this.af_1);
        result = imul(result, 31) + (this.bf_1 == null ? 0 : hashCode(this.bf_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Pair()))
          return false;
        if (!equals(this.af_1, other.af_1))
          return false;
        if (!equals(this.bf_1, other.bf_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Pair');
    PairClass = $;
  }
  return PairClass;
}
function to(_this__u8e3s4, that) {
  return new (Pair())(_this__u8e3s4, that);
}
var TripleClass;
function Triple() {
  if (TripleClass === VOID) {
    class $ {
      constructor(first, second, third) {
        this.tw_1 = first;
        this.uw_1 = second;
        this.vw_1 = third;
      }
      toString() {
        return '(' + toString(this.tw_1) + ', ' + toString(this.uw_1) + ', ' + toString(this.vw_1) + ')';
      }
      cf() {
        return this.tw_1;
      }
      df() {
        return this.uw_1;
      }
      ww() {
        return this.vw_1;
      }
      hashCode() {
        var result = this.tw_1 == null ? 0 : hashCode(this.tw_1);
        result = imul(result, 31) + (this.uw_1 == null ? 0 : hashCode(this.uw_1)) | 0;
        result = imul(result, 31) + (this.vw_1 == null ? 0 : hashCode(this.vw_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Triple()))
          return false;
        if (!equals(this.tw_1, other.tw_1))
          return false;
        if (!equals(this.uw_1, other.uw_1))
          return false;
        if (!equals(this.vw_1, other.vw_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Triple');
    TripleClass = $;
  }
  return TripleClass;
}
function toList(_this__u8e3s4) {
  return listOf([_this__u8e3s4.af_1, _this__u8e3s4.bf_1]);
}
//region block: exports
export {
  Pair as Paire9pteg33gng7,
  Triple as Triple1vhi3d0dgpnjb,
  toList as toList2vkrbx8s6dfjs,
  to as to2cs3ny02qtbcb,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
